import { PlayerDetails } from "@/lib/types";
import { selectActiveFirm } from "@/store/appSelectors";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { constructPlayerSchedule } from "./PlayerScheduleDetailUtils";
import { useQuery } from "@tanstack/react-query";
import { LoadingSmall } from "@/components/LoadingSmall";
import React from "react";
import { getAllPlayerDetails } from "@/sideEffects/api";
import { computeActiveContentOrContentGroup } from "@/components/ds/lib/DSProcessor";
import { ScheduleSection } from "./ScheduleSection";

interface Props {
  playerDetails: PlayerDetails;
}

export const PlayerScheduleDetail: React.FC<Props> = ({ playerDetails }) => {
  const { t } = useTranslation();
  const activeFirm = useSelector(selectActiveFirm);

  const { data: playerSchedule, isFetching } = useQuery({
    queryFn: () => constructPlayerSchedule(playerDetails, String(activeFirm?.firmGuid), playerDetails.timezone),
    queryKey: ["playerSchedule"],
  });

  const { data: dsPlayerDetails } = useQuery({
    queryKey: ["getAllPlayerDetails", playerDetails.id],
    queryFn: () => getAllPlayerDetails(String(activeFirm?.firmGuid), String(playerDetails.id)),
  });

  if (dsPlayerDetails?.data) {
    console.log(computeActiveContentOrContentGroup(dsPlayerDetails?.data));
  }

  if (isFetching) {
    return <LoadingSmall />;
  }

  if (!playerSchedule?.campaignConfs && !playerSchedule?.channelConf) {
    return <div className="text-sm text-muted-foreground">{t("schedule.noSchedule")}</div>;
  }

  const activeContentOrContentGroup = dsPlayerDetails?.data
    ? computeActiveContentOrContentGroup(dsPlayerDetails?.data)
    : null;

  return (
    <>
      {activeContentOrContentGroup && (
        <div className="flex items-center gap-2 mb-4">
          <span className="text-sm text-muted-foreground">{t("schedule.currentlyServing")}</span>
          <span className="text-sm font-bold">{activeContentOrContentGroup.source}</span>
        </div>
      )}
      <div className="space-y-4">
        {playerSchedule.channelConf && (
          <ScheduleSection
            conf={playerSchedule.channelConf}
            type="channel"
            isOverridenByArea={playerSchedule.isOverridenByArea}
          />
        )}
        {playerSchedule.campaignConfs?.map((conf, index) => (
          <ScheduleSection
            key={index}
            conf={conf}
            type="campaign"
            isOverridenByArea={playerSchedule.isOverridenByArea}
          />
        ))}
      </div>
    </>
  );
};
